import { FC, useContext, useEffect, useMemo, autoSet } from 'external/react'
import {styled} from 'external/material'
import { TextAreaField } from 'components/common/TextAreaField'
import { TeacherContext } from 'teacher/context'
import StrategyDropdown from './StrategyDropdown';

export const MOMENT = ['start', 'development', 'end'] as const;
export type MomentOfDayId = typeof MOMENT[number];

export const PHASE = ['activities', 'evidence', 'organization', 'resources', 'metacognition', 'instruments'] as const;
export type Phase = typeof PHASE[number];

type MomentPhases<T> = {
  [K in Phase]: T
}

type MomentOfDay = {
  id: MomentOfDayId,
  description: string,
  strategies: Array<number>,
} & MomentPhases<string>

type DayMomentProps = {
  id: number
  className?: string
  moment: MomentOfDayId
}

const StyledDayMoment = styled('div')(dayMomentStyles as any)

const DayMoment: FC<DayMomentProps> = props => {
  
    const {id, moment, className} = props
    const {translate, updateState, newPlan} = useContext(TeacherContext) as any

    const dailyPlan = useMemo(() => {
      const dailyPlans = newPlan.content.dailyPlanning
      const dailyPlan = dailyPlans[id]
      return dailyPlan
    }, [ newPlan.content.dailyPlanning, id])

    const dailyMoment = useMemo(() => (dailyPlan[moment] || false), [dailyPlan, moment]) 

    function editPhase (phase: 'description' | Phase, value: string) {
      updateState({newPlan: {content: {dailyPlanning: {[id]: autoSet(value, moment, phase)}}}})
    }

    const phases = useMemo(() => PHASE.map(phase => (
      <TextAreaField 
        key={phase}
        label={translate(`planning-rd-phase-${phase}`).toUpperCase()}
        value={dailyMoment[phase]}
        labelStyles={{fontWeight: 'bold'}}
        textAreaStyles={{height: '190px'}}
        onChange={value => editPhase(phase, value)}
      />
    )), [id, moment, translate])

    return (<StyledDayMoment className={className}>
      <StrategyDropdown id={id} moment={moment} />
      <TextAreaField className="description-text" label={''} value={dailyMoment.description} textAreaStyles={{height: '70px'}} onChange={value => editPhase('description', value)} />
      <div className="phases-grid">
        {phases}
       </div>
    </StyledDayMoment>
    )
}

export {DayMoment as default}

function dayMomentStyles() {
  return {
    display: 'flex',
    padding: 24,
    flexDirection: 'column',
    backgroundColor: 'rgba(165, 211, 243, 0.2)',
    '& > .description-text': {
      marginBottom: 25
    },
    '& .phases-grid': {
      width: '100%', 
      display: 'grid',
      gridTemplateColumns: '1fr 1fr 1fr',
      gridTemplateRows: '1fr 1fr',
      rowGap: '40px',
      columnGap: '40px',
      height: '100%',
      boxSizing: 'border-box'
    }
  }
}